var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComentarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hlbVQT.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1128.3,1091.65l-65.75-213.2c65.66-80.59,117.56-178.84,123.63-287.92C1204.79,256.75,875.62,54.04,597.67,54.98,304.66,55.98-38.01,282.99,19.42,637.77c58.38,360.63,510.06,508.63,801.82,396.4l270.69,92.75c21.98,7.53,43.22-13.06,36.37-35.26ZM760.26,563.77c0-56.6,43-102.48,96.04-102.48s96.04,45.88,96.04,102.48-43,102.48-96.04,102.48-96.04-45.88-96.04-102.48ZM503.77,563.77c0-56.6,43-102.48,96.04-102.48s96.04,45.88,96.04,102.48-43,102.48-96.04,102.48-96.04-45.88-96.04-102.48ZM247.29,563.77c0-56.6,43-102.48,96.04-102.48s96.04,45.88,96.04,102.48-43,102.48-96.04,102.48-96.04-45.88-96.04-102.48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComentarios);
export default __webpack_public_path__ + "static/media/comentarios.28c84cf5b35ebfed2ff455b8d20f6a47.svg";
export { ForwardRef as ReactComponent };